import type { CompatibleLanguage } from '@seek/ca-myprofile-utils';
import type { TranslationKeys } from '@vocab/core';
import { useTranslations } from '@vocab/react';

import translations from './.vocab';

type Tab = TranslationKeys<typeof translations>;

const mapSiteAndLanguageToBrandAndCountry: Record<string, string> = {
  'candidate-seek-au-en': 'SEEK Australia',
  'candidate-seek-nz-en': 'SEEK New Zealand',
  'candidate-jobsdb-hk-en': 'Jobsdb Hong Kong',
  'candidate-jobsdb-th-en': 'Jobsdb Thailand',
  'candidate-jobsdb-th-th': 'Jobsdb ประเทศไทย',
  'candidate-jobstreet-sg-en': 'Jobstreet Singapore',
  'candidate-jobstreet-id-en': 'Jobstreet Indonesia',
  'candidate-jobstreet-id-id': 'Jobstreet Indonesia',
  'candidate-jobstreet-ph-en': 'Jobstreet Philippines',
  'candidate-jobstreet-my-en': 'Jobstreet Malaysia',
};

export const useGetPageTitle = (
  site: string = 'candidate-seek-au',
  language: CompatibleLanguage = 'en',
  tab: Tab,
): string => {
  const { t } = useTranslations(translations);

  const brandAndCountryText =
    mapSiteAndLanguageToBrandAndCountry[`${site}-${language}`] ||
    'SEEK Australia';
  const tabTitle = t(tab);

  return `${tabTitle} | ${brandAndCountryText}`;
};
